import api from '@utils/api';
import { getWithExpiry, setWithExpiry } from '@utils/localStorageUtils';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Smooch from 'smooch';
import { removeChatInfosFromStorage, sendInfoJSON, sendIsOnlineRequest } from './ChatUtils';
import useChatTranslation from './useChatTranslation';
let firstJsonSent = false;
let timeoutId;
const ChatSmooch = (props) => {
    var _a;
    const [user, setUser] = useState();
    const [miniCart, setMiniCart] = useState();
    const customText = useChatTranslation();
    const { t } = useTranslation();
    const minicartReady = Object(miniCart).hasOwnProperty('items');
    const userReady = Object(user).hasOwnProperty('email');
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        /*
          ============================================================
          workaround in order to update JSON when page change with react router
          ============================================================
        */
        //@ts-ignore
        window.chatObject = {
            internalValue: new Date().getTime(),
            valueListener: function (val) { },
            set value(val) {
                this.internalValue = val;
                this.valueListener(val);
            },
            get value() {
                return this.internalValue;
            },
            registerListener: function (listener) {
                this.valueListener = listener;
            },
        };
        //============================================================
        if (!getWithExpiry('livechatid')) {
            removeChatInfosFromStorage(props.integrationid);
            //set expire for two hours
            setWithExpiry('livechatid', props.integrationid, 7200000);
        }
        api.getUserInfo().then((info) => {
            setUser(info);
        });
        api.getMiniCart().then((cart) => {
            setMiniCart(cart);
        });
        initiSmooch();
        return () => {
            clearTimeout(timeoutId);
        };
    }, []);
    useEffect(() => {
        if (minicartReady && userReady && !firstJsonSent && !loading) {
            firstJsonSent = true;
            sendInfoJSON(user, miniCart);
            //@ts-ignore
            window.chatObject.registerListener(() => {
                sendInfoJSON(user, miniCart);
            });
        }
    }, [miniCart, user, loading]);
    const showChat = (openChat = false) => {
        var _a;
        document.getElementById('web-messenger-container').style.display = 'block';
        (_a = document.querySelector('.chat-message')) === null || _a === void 0 ? void 0 : _a.classList.add('visible');
        if (openChat) {
            Smooch.open();
        }
        timeoutId = setTimeout(() => {
            var _a;
            (_a = document.querySelector('.chat-message')) === null || _a === void 0 ? void 0 : _a.classList.add('collapsed');
        }, 6000);
    };
    const initiSmooch = () => {
        Smooch.init({
            integrationId: props.integrationid,
            embedded: false,
            businessName: 'MONCLER LIVE CHAT',
            businessIconUrl: `${window.staticurl}logo.png`,
            locale: window.location.pathname.split('/')[1],
            soundNotificationEnabled: false,
            prechatCapture: {
                avatarUrl: 'https://media.yoox.biz/ytos/resources/MONCLER/accessibility/icons/png/logo-moncler.png',
            },
            integrationOrder: [],
            canUserSeeConversationList: false,
            displayStyle: 'button',
            // buttonIconUrl: `${window.staticurl}chat-white.svg`,
            buttonWidth: '48px',
            buttonHeight: '48px',
            fixedHeader: !!(props === null || props === void 0 ? void 0 : props.app),
            customColors: {
                brandColor: '000000',
                conversationColor: 'b7b7b5',
                actionColor: '000000',
            },
            customText: customText,
            menuItems: {
                imageUpload: true,
                fileUpload: true,
                shareLocation: true,
            },
        }).then(function () {
            var _a;
            document.head.insertAdjacentHTML('beforeend', `<script>
        !function(o,p,s,e,c){
            var i,a,h,u=[],d=[];function t(){var t="You must provide a supported major version.";try{if(!c)throw new Error(t);var e,n="https://cdn.smooch.io/",r="smooch";if((e="string"==typeof this.response?JSON.parse(this.response):this.response).url){var o=p.getElementsByTagName("script")[0],s=p.createElement("script");s.async=!0;var i=c.match(/([0-9]+)\.?([0-9]+)?\.?([0-9]+)?/),a=i&&i[1];if(i&&i[3])s.src=n+r+"."+c+".min.js";else{if(!(4<=a&&e["v"+a]))throw new Error(t);s.src=e["v"+a]}o.parentNode.insertBefore(s,o)}}catch(e){e.message===t&&console.error(e)}}o[s]={init:function(){i=arguments;var t={then:function(e){return d.push({type:"t",next:e}),t},catch:function(e){return d.push({type:"c",next:e}),t}};return t},on:function(){u.push(arguments)},render:function(){a=arguments},destroy:function(){h=arguments}},o.__onWebMessengerHostReady__=function(e){if(delete o.__onWebMessengerHostReady__,o[s]=e,i)for(var t=e.init.apply(e,i),n=0;n<d.length;n++){var r=d[n];t="t"===r.type?t.then(r.next):t.catch(r.next)}a&&e.render.apply(e,a),h&&e.destroy.apply(e,h);for(n=0;n<u.length;n++)e.on.apply(e,u[n])};var n=new XMLHttpRequest;n.addEventListener("load",t),n.open("GET","https://"+e+".webloader.smooch.io/",!0),n.responseType="json",n.send()
            }(window,document,"Smooch","${props.integrationid}","5");
      </script>`);
            Smooch.setDelegate({
                beforeDisplay(message) {
                    if (message.metadata && message.metadata.isHidden) {
                        return null;
                    }
                    return message;
                },
            });
            const conversationId = (_a = Smooch.getDisplayedConversation()) === null || _a === void 0 ? void 0 : _a.id;
            sendIsOnlineRequest(props.integrationid, window.datalayerdata.pageLanguage, conversationId).then((response) => {
                if (response.Result) {
                    // fallback per i bottoni non ancora renderizzati a chiamata conclusa
                    //@ts-ignore
                    const chatButtons = document.querySelectorAll('.chat-button');
                    if (chatButtons.length > 0) {
                        chatButtons.forEach((btn) => {
                            // btn.addEventListener('click', (e) => {
                            //   showChat(true);
                            // });
                            // btn.classList.remove('greyed');
                            btn.removeAttribute('disabled');
                        });
                    }
                    document.addEventListener('click', (event) => {
                        //@ts-ignore
                        if (event.target.matches('.chat-button, .chat-button *') && window.chatavailable) {
                            showChat(true);
                        }
                    }, false);
                    if (window.chatavailable)
                        showChat(props === null || props === void 0 ? void 0 : props.app);
                }
                else {
                    const chatText = document.querySelector('.chat-message');
                    const chatButtons = document.querySelectorAll('.chat-button');
                    if (chatButtons.length > 0) {
                        chatButtons.forEach((btn) => {
                            btn.innerHTML = t('chat.notavailable');
                        });
                    }
                    if (chatText) {
                        chatText.style.display = 'none';
                    }
                    // const messageButton = document.getElementById('messenger-button');
                    // if (messageButton) {
                    //   messageButton.classList.add('greyed');
                    // }
                }
            });
        }, function (err) {
            console.log('smootch initialization error: ' + err);
        });
        Smooch.on('message', () => {
            //reset expiring date
            setWithExpiry('livechatid', props.integrationid, 7200000);
            //check if there are some link with template [text](url)
            const lastMessageDivs = document.getElementById('web-messenger-container').contentDocument.querySelectorAll('.message-item.message-text.last-item');
            lastMessageDivs === null || lastMessageDivs === void 0 ? void 0 : lastMessageDivs.forEach((lastMessageDiv) => {
                const lastMessage = lastMessageDiv === null || lastMessageDiv === void 0 ? void 0 : lastMessageDiv.innerHTML;
                if (lastMessage === null || lastMessage === void 0 ? void 0 : lastMessage.includes('](')) {
                    const linkUrl = lastMessage.match(/\((.*)\)/);
                    const linkText = lastMessage.match(/\[(.*?)\]/);
                    const url = `<a href="${linkUrl[1]}">${linkText[1]}</a>`;
                    lastMessageDiv.innerHTML = lastMessage.replace(linkText[0], '').replace(linkUrl[0], url);
                }
            });
        });
        Smooch.on('widget:closed', () => {
            if (window.innerWidth < window.mqObj.sm) {
                document.body.classList.remove('no-overflow');
            }
        });
        Smooch.on('widget:opened', () => {
            var _a;
            if (window.innerWidth < window.mqObj.sm) {
                document.body.classList.add('no-overflow');
            }
            (_a = document.querySelector('.chat-message')) === null || _a === void 0 ? void 0 : _a.classList.remove('visible');
            if (!firstJsonSent) {
                setLoading(false);
            }
        });
        Smooch.on('widget:closed', () => { var _a; return (_a = document.querySelector('.chat-message')) === null || _a === void 0 ? void 0 : _a.classList.add('visible'); });
    };
    return (['myaccount', 'clientservice'].includes((_a = window.datalayerdata) === null || _a === void 0 ? void 0 : _a.pageCategory) && (React.createElement("div", { className: "chat-message" }, window.datalayerdata.pageCategory == 'clientservice' ? t('chat.message.contactus') : t('chat.message.myaccount'))));
};
export default ChatSmooch;
